import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '~/redux/configureStore';
import CourseBuilder from '~/components/courses/course-builder';
import QuizBuilder from '~/components/quizzes/quiz-builder';
import ErrorBoundary from '~/components/common/error-boundary';
import '~/sass/builder.scss';

const errorMessage =
	'undefined' !== typeof LearnDashData
		? LearnDashData.error_messages &&
		  LearnDashData.error_messages.header &&
		  LearnDashData.error_messages.header
		: 'Sorry, something went wrong with LearnDash.';

ReactDOM.render(
	<ErrorBoundary message={ errorMessage } className="builder-boundary">
		<Provider store={ store }>
			{ 'sfwd-quiz' === LearnDashData.post_data.builder_post_type ? (
				<QuizBuilder />
			) : (
				<CourseBuilder />
			) }
		</Provider>
	</ErrorBoundary>,
	document.getElementById( 'learndash_builder_box_wrap' )
);
